<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main aria-label="form">
      <h1 id="main-title" class="vtz-h1" i18n>Organization Key</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        Please enter the 6-digit Organization Verification Key provided by the election administrator.
      </p>
      <div class="vtz-form">
        @if(userService.isOrgVerificationAllowed) {
          <div id="otp" class="otp-field">
            @for (index of numbers; track index) {
              <input
                #orgKeyRef
                type="text"
                maxlength="1"
                pattern="[0-9]"
                required
                [attr.aria-label]="'Digit' +(index + 1)+ 'of 6'"               
                autocomplete="off"
                (focus)="handleFocus($event)"
                (input)="handleInput($event, index)"
                (paste)="handlePaste($event)"
                (blur)="index === 5 && handleBlur($event)"
                inputmode="numeric"
              />
            }
          </div>
        }
    
        @if(orgKeyFormGroup.get('code')?.hasError('invalidPaste')){
          <div role="alert" class="vtz-text--center">
            <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Pasted code must contain exactly 6 numbers.
            </span>
          </div>
        }
        @if(orgKeyFormGroup.get('code')?.hasError('invalidCode')){
          <div role="alert" class="vtz-text--center">
            <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Exactly six digits are required in this field.
            </span>
          </div>
        }
        <div class="button-group">
          <button class="button button-secondary" (click)="back()" i18n="Button label">CANCEL</button>
          @if(userService.isOrgVerificationAllowed) {
            <div class="vtz-spacer-10"></div>
            <button class="button button-primary" [disabled]="!isValidCode(orgKeyFormGroup.value.code)" (click)="submit()" i18n="Button label">ADD</button>
          }
        </div>
      </div>
      @if (displaySpinner) {
        <div class="progressSpinner">
          <mat-spinner [diameter]="300" color="primary"></mat-spinner>
          <div class="spinner-warning">
            <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
          </div>
        </div>
      }
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>
